/**
 * DevModeBadge — Sayfa header'ında veya layout'ta görünen "Developer Mode" göstergesi.
 * Kullanıcının Developer (veya SuperAdmin) rolünde olduğunu hatırlatır.
 * Sadece Developer için tam kırmızı, SuperAdmin için soft turuncu.
 */
import React from 'react';
import { Wrench, ShieldCheck } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

export default function DevModeBadge() {
  const { user, isDeveloper, isSuperAdmin } = useAuth();
  if (!user) return null;
  if (!isDeveloper() && !isSuperAdmin()) return null;

  const isDev = isDeveloper();
  const cls = isDev
    ? 'bg-red-600 text-white animate-pulse'
    : 'bg-orange-500 text-white';
  const Icon = isDev ? Wrench : ShieldCheck;
  const label = isDev ? 'DEVELOPER MODE' : 'ADMIN MODE';

  return (
    <div
      className={`inline-flex items-center gap-1.5 px-2 sm:px-2.5 py-1 rounded-md text-xs font-bold shadow-md shrink-0 ${cls}`}
      title={isDev ? 'Geliştirici modu — tüm aksiyonlar audit log\'a yazılır' : 'Yönetici modu'}
    >
      <Icon className="w-3.5 h-3.5 shrink-0" />
      {/* İt-fix (2026-07-14): dar/mobil ekranda header taşmasını önle — text'i md altında gizle, ikon kalır */}
      <span className="hidden md:inline">{label}</span>
    </div>
  );
}
